import { useCallback, useEffect, useState } from 'react';
import { fetchCards } from '../services/cardsApi';

const useCards = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCards = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchCards();
      setCards(data);
    } catch (err) {
      setError(err.message || 'Failed to load cards');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCards();
  }, [loadCards]);

  const refetch = useCallback(async () => {
    try {
      setError(null);
      const data = await fetchCards();
      setCards(data);
    } catch (err) {
      setError(err.message || 'Failed to load cards');
    }
  }, []);

  return { cards, loading, error, refetch };
};

export default useCards;
